import { create } from 'zustand';

export enum ClawStatus {
  NOT_OPEN = 0,
  OPENING = 1,
  OPENED = 2,
  ERROR = 3,
}

export enum PendingStep {
  PREPARING = 0,  // 正在准备你的专属助手
  LOADING_AI = 1, // 加载 AI 核心能力
  INSTALLING = 2, // 安装技能包
  STARTING = 3,   // 启动服务
  COMPLETE = 4,   // 一切准备好了，现在就开始
}

export const PENDING_STEP_LABELS: Record<PendingStep, string> = {
  [PendingStep.PREPARING]: '正在准备你的专属助手',
  [PendingStep.LOADING_AI]: '加载 AI 核心能力',
  [PendingStep.INSTALLING]: '安装技能包',
  [PendingStep.STARTING]: '启动服务',
  [PendingStep.COMPLETE]: '一切准备好了，现在就开始',
};

export const PENDING_STEP_PROGRESS: Record<PendingStep, number> = {
  [PendingStep.PREPARING]: 20,
  [PendingStep.LOADING_AI]: 40,
  [PendingStep.INSTALLING]: 60,
  [PendingStep.STARTING]: 80,
  [PendingStep.COMPLETE]: 100,
};

interface ClawStatusState {
  status: ClawStatus;
  init: boolean;
  pendingStep: PendingStep;
  /** 正在查询 Bot 状态（查询完成前不渲染具体视图） */
  checking: boolean;
  setStatus: (status: ClawStatus) => void;
  setInit: (init: boolean) => void;
  setPendingStep: (step: PendingStep) => void;
  setChecking: (checking: boolean) => void;
}

const useClawStatus = create<ClawStatusState>((set) => ({
  status: ClawStatus.NOT_OPEN,
  init: false,
  pendingStep: PendingStep.PREPARING,
  checking: true,
  setInit: (init: boolean) => set({ init }),
  setStatus: (status) => set({ status }),
  setPendingStep: (pendingStep) => set({ pendingStep }),
  setChecking: (checking) => set({ checking }),
}));

export default useClawStatus;
